import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import SocialMirrorLogo from '@/assets/socialMirror/SocialMirrorLogo.svg?react'
import { Button } from '@/components/ui/button'
import { AppRoutes } from '@/constants/appRoutes'
import { trackOnboardingStepViewed, OnboardingSteps } from '@/utils/analytics'

export const WelcomeToSelfCheck = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const hasTrackedView = useRef(false)

  // Track step viewed once on mount
  useEffect(() => {
    if (!hasTrackedView.current) {
      trackOnboardingStepViewed(OnboardingSteps.WELCOME)
      hasTrackedView.current = true
    }
  }, [])

  const handleContinue = () => {
    navigate(AppRoutes.motivation)
  }

  return (
    <div className="w-full h-full flex flex-col justify-center">
      <div className="flex flex-col gap-4 items-center justify-between">
        <div className="max-md:w-full w-6/10 flex justify-center flex-col items-center gap-8 bg-baseColorHighlight border border-neuralColor5 rounded-2xl p-8">
          <div className="flex flex-col gap-6 items-center">
            <SocialMirrorLogo width={32} height={32} />
            <p className="text-[32px] max-md:text-3xl font-medium text-center">
              {t('signUp.welcome.title')}
            </p>
            <div className="flex flex-col items-center text-center">
              <p className="text-base max-md:text-xl text-neutralColor80 font-medium">
                {t('signUp.welcome.subtitle1')}
              </p>
              <p className="text-base max-md:text-xl text-neutralColor80 font-medium">
                {t('signUp.welcome.subtitle2')}
              </p>
            </div>
          </div>
          <Button
            onClick={handleContinue}
            className="w-full text-base font-bold"
          >
            {t('common.continue')}
          </Button>
        </div>
      </div>
      <div className="flex justify-center w-full">
        <p className="fixed bottom-5 text-neutralColor60 text-base font-medium text-center">
          {t('signUp.welcome.footer')}
        </p>
      </div>
    </div>
  )
}
